import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const FooterContainer = styled.footer`
  background-color: #212121;
  color: #a9a9a9;
  padding: 60px 0 20px;
  font-family: Arial, sans-serif;
`;

export const FooterWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

export const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #444;
  padding-bottom: 40px;
  margin-bottom: 40px;
  flex-wrap: wrap;
  gap: 40px;
`;

export const NewsletterSection = styled.div`
  flex: 1;
  min-width: 300px;

  h3 {
    color: #ffffff;
    font-size: 18px;
    margin-top: 0;
    margin-bottom: 15px;
  }

  p {
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 20px;
  }
`;

export const NewsletterForm = styled.form`
  display: flex;
`;

export const NewsletterInput = styled.input`
  flex-grow: 1;
  padding: 12px;
  border: 1px solid #555;
  background-color: #333;
  color: #fff;
  border-radius: 4px 0 0 4px;
  font-size: 14px;

  &::placeholder {
    color: #888;
  }

  &:focus {
    outline: none;
    border-color: #005eb8;
  }
`;

export const NewsletterButton = styled.button`
  padding: 12px 20px;
  background-color: #005eb8;
  color: #ffffff;
  border: none;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  transition: background-color 0.3s;

  &:hover {
    background-color: #004a94;
  }
`;

export const LinksGrid = styled.div`
  flex: 2;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 30px;
`;

export const LinkColumn = styled.div``;

export const ColumnTitle = styled.h4`
  color: #ffffff;
  font-size: 16px;
  margin-top: 0;
  margin-bottom: 20px;
`;

export const FooterLinkList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const FooterLinkItem = styled.li`
  margin-bottom: 12px;
`;

export const FooterLink = styled(Link)`
  color: #a9a9a9;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;

  &:hover {
    color: #ffffff;
    text-decoration: underline;
  }
`;

export const MiddleSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 40px;
  margin-bottom: 40px;
  border-bottom: 1px solid #444;
  flex-wrap: wrap;
  gap: 30px;
`;

export const SocialsSection = styled.div`
  h4 {
    color: #ffffff;
    font-size: 16px;
    margin-top: 0;
    margin-bottom: 15px;
  }
`;

export const SocialIcons = styled.div`
  display: flex;
  gap: 15px;

  a {
    color: #a9a9a9;
    font-size: 24px;
    transition: color 0.3s;

    &:hover {
      color: #ffffff;
    }
  }
`;

export const PaymentsSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  img {
    height: 24px;
    width: auto;
  }
`;

export const RegulatorySection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding-bottom: 40px;
  margin-bottom: 40px;
  border-bottom: 1px solid #444;
  flex-wrap: wrap;

  img {
    height: 40px;
    width: auto;
  }
`;

export const TrustpilotWidgetWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 2rem; /* Add space below the widget */
`;

export const BottomBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  flex-wrap: wrap;
  gap: 15px;
`;

export const Copyright = styled.p`
  margin: 0;
`;

export const BottomLinks = styled.div`
  display: flex;
  gap: 20px;
`;